const CarBrandList: readonly string[] = [
    'Acura',
    'Audi',
    'BMW',
    'Buick',
    'Cadillac',
    'Chevrolet',
    'Chrysler',
    'Citroen',
    'Dodge',
    'Ferrari',
    'Fiat',
    'Ford',
    'Honda',
    'Hyundai',
    'Infiniti',
    'Jaguar',
    'Jeep',
    'KIA',
    'Lamborghini',
    'Lexus',
    'Lincoln',
    'Mazda',
    'Mercedes',
    'Mitsubishi',
    'Nissan',
    'Peugeot',
    'Renault',
    'Subaru',
    'Suzuki',
    'Tesla',
    'Toyota',
    'Volkswagen'
];

export default CarBrandList;